// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/support/v1/requests.proto (package gportal.api.support.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { SupportAddonType } from "./support_addons_pb.js";
import { SupportMessageRating } from "./support_message_pb.js";

/**
 * @generated from message gportal.api.support.v1.CreateTicketRequest
 */
export class CreateTicketRequest extends Message<CreateTicketRequest> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: optional string support_category_id = 2;
   */
  supportCategoryId?: string;

  /**
   * @generated from field: string gameserver_id = 3;
   */
  gameserverId = "";

  /**
   * @generated from field: string body = 4;
   */
  body = "";

  /**
   * Optionally you can buy an additional addon for the ticket
   *
   * @generated from field: optional gportal.api.support.v1.SupportAddonType addon = 5;
   */
  addon?: SupportAddonType;

  /**
   * If a addon has selected, then a coupon code can be provided for discount
   *
   * @generated from field: optional string coupon_code = 6;
   */
  couponCode?: string;

  constructor(data?: PartialMessage<CreateTicketRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.CreateTicketRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "support_category_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "gameserver_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "addon", kind: "enum", T: proto3.getEnumType(SupportAddonType), opt: true },
    { no: 6, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTicketRequest {
    return new CreateTicketRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTicketRequest {
    return new CreateTicketRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTicketRequest {
    return new CreateTicketRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTicketRequest | PlainMessage<CreateTicketRequest> | undefined, b: CreateTicketRequest | PlainMessage<CreateTicketRequest> | undefined): boolean {
    return proto3.util.equals(CreateTicketRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.CreateSupportMessageRequest
 */
export class CreateSupportMessageRequest extends Message<CreateSupportMessageRequest> {
  /**
   * Accepts a prefixed ticket id (`legacy:<uuid>` / `intercom:<conversation_id>`); the backend strips
   * the prefix to route by source, so this can no longer be a strict uuid.
   *
   * @generated from field: string ticket_id = 1;
   */
  ticketId = "";

  /**
   * @generated from field: string body = 2;
   */
  body = "";

  /**
   * Files to attach to this reply. INTERCOM-BACKED TICKETS ONLY: supplying any on a legacy ticket
   * fails the call with UNIMPLEMENTED rather than dropping them silently.
   *
   * Attachments ride on the reply because Intercom has no standalone upload endpoint —
   * `attachment_files` is a property of POST /conversations/{id}/reply, which also requires a body.
   * So there is no such thing as sending a file without a message.
   *
   * Capped at 3 here and 2 MB per file in the handler. Both are OUR limits, not Intercom's:
   * Intercom allows 10 files per reply and documents no size limit at all.
   *
   * @generated from field: repeated gportal.api.support.v1.TicketAttachment attachments = 3;
   */
  attachments: TicketAttachment[] = [];

  constructor(data?: PartialMessage<CreateSupportMessageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.CreateSupportMessageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "attachments", kind: "message", T: TicketAttachment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSupportMessageRequest {
    return new CreateSupportMessageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSupportMessageRequest {
    return new CreateSupportMessageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSupportMessageRequest {
    return new CreateSupportMessageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSupportMessageRequest | PlainMessage<CreateSupportMessageRequest> | undefined, b: CreateSupportMessageRequest | PlainMessage<CreateSupportMessageRequest> | undefined): boolean {
    return proto3.util.equals(CreateSupportMessageRequest, a, b);
  }
}

/**
 * A file being uploaded with a reply.
 *
 * @generated from message gportal.api.support.v1.TicketAttachment
 */
export class TicketAttachment extends Message<TicketAttachment> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string content_type = 2;
   */
  contentType = "";

  /**
   * The raw file. `bytes` rather than a base64 string on purpose: proto3 JSON already encodes bytes
   * as base64, so the wire form is identical either way, but the server receives real bytes and can
   * size-check the DECODED length. Checking a base64 string instead measures something 4/3 larger and
   * rejects files that are comfortably under the limit.
   *
   * Re-encoded to base64 exactly once, at the Intercom boundary.
   *
   * @generated from field: bytes data = 3;
   */
  data = new Uint8Array(0);

  constructor(data?: PartialMessage<TicketAttachment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.TicketAttachment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TicketAttachment {
    return new TicketAttachment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TicketAttachment {
    return new TicketAttachment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TicketAttachment {
    return new TicketAttachment().fromJsonString(jsonString, options);
  }

  static equals(a: TicketAttachment | PlainMessage<TicketAttachment> | undefined, b: TicketAttachment | PlainMessage<TicketAttachment> | undefined): boolean {
    return proto3.util.equals(TicketAttachment, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.GetTicketsRequest
 */
export class GetTicketsRequest extends Message<GetTicketsRequest> {
  constructor(data?: PartialMessage<GetTicketsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.GetTicketsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTicketsRequest {
    return new GetTicketsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTicketsRequest {
    return new GetTicketsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTicketsRequest {
    return new GetTicketsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTicketsRequest | PlainMessage<GetTicketsRequest> | undefined, b: GetTicketsRequest | PlainMessage<GetTicketsRequest> | undefined): boolean {
    return proto3.util.equals(GetTicketsRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.RateSupportMessageRequest
 */
export class RateSupportMessageRequest extends Message<RateSupportMessageRequest> {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId = "";

  /**
   * @generated from field: gportal.api.support.v1.SupportMessageRating rating = 2;
   */
  rating = SupportMessageRating.UNSPECIFIED;

  constructor(data?: PartialMessage<RateSupportMessageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.RateSupportMessageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rating", kind: "enum", T: proto3.getEnumType(SupportMessageRating) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RateSupportMessageRequest {
    return new RateSupportMessageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RateSupportMessageRequest {
    return new RateSupportMessageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RateSupportMessageRequest {
    return new RateSupportMessageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RateSupportMessageRequest | PlainMessage<RateSupportMessageRequest> | undefined, b: RateSupportMessageRequest | PlainMessage<RateSupportMessageRequest> | undefined): boolean {
    return proto3.util.equals(RateSupportMessageRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.ListSupportInfosRequest
 */
export class ListSupportInfosRequest extends Message<ListSupportInfosRequest> {
  /**
   * @generated from field: optional string locale = 1;
   */
  locale?: string;

  constructor(data?: PartialMessage<ListSupportInfosRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.ListSupportInfosRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSupportInfosRequest {
    return new ListSupportInfosRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSupportInfosRequest {
    return new ListSupportInfosRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSupportInfosRequest {
    return new ListSupportInfosRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSupportInfosRequest | PlainMessage<ListSupportInfosRequest> | undefined, b: ListSupportInfosRequest | PlainMessage<ListSupportInfosRequest> | undefined): boolean {
    return proto3.util.equals(ListSupportInfosRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.GetTicketRequest
 */
export class GetTicketRequest extends Message<GetTicketRequest> {
  /**
   * Accepts a prefixed ticket id (`legacy:<uuid>` / `intercom:<conversation_id>`); the backend strips
   * the prefix to route by source, so this can no longer be a strict uuid.
   *
   * @generated from field: string ticket_id = 1;
   */
  ticketId = "";

  constructor(data?: PartialMessage<GetTicketRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.GetTicketRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTicketRequest {
    return new GetTicketRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTicketRequest {
    return new GetTicketRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTicketRequest {
    return new GetTicketRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTicketRequest | PlainMessage<GetTicketRequest> | undefined, b: GetTicketRequest | PlainMessage<GetTicketRequest> | undefined): boolean {
    return proto3.util.equals(GetTicketRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.CloseTicketRequest
 */
export class CloseTicketRequest extends Message<CloseTicketRequest> {
  /**
   * @generated from oneof gportal.api.support.v1.CloseTicketRequest.ticket_identifier
   */
  ticketIdentifier: {
    /**
     * Accepts a prefixed ticket id (`legacy:<id>` / `intercom:<conversation_id>`); the backend strips
     * the prefix to route by source, so this can no longer be a strict uuid.
     *
     * @generated from field: string ticket_id = 1;
     */
    value: string;
    case: "ticketId";
  } | {
    /**
     * @generated from field: uint64 ticket_numeric_id = 2;
     */
    value: bigint;
    case: "ticketNumericId";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<CloseTicketRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.CloseTicketRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "ticket_identifier" },
    { no: 2, name: "ticket_numeric_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */, oneof: "ticket_identifier" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CloseTicketRequest {
    return new CloseTicketRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CloseTicketRequest {
    return new CloseTicketRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CloseTicketRequest {
    return new CloseTicketRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CloseTicketRequest | PlainMessage<CloseTicketRequest> | undefined, b: CloseTicketRequest | PlainMessage<CloseTicketRequest> | undefined): boolean {
    return proto3.util.equals(CloseTicketRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.ChargeAddonTicketRequest
 */
export class ChargeAddonTicketRequest extends Message<ChargeAddonTicketRequest> {
  /**
   * Legacy web-interface numeric ticket id (used by the website).
   *
   * @generated from field: uint64 ticket_id = 1;
   */
  ticketId = protoInt64.zero;

  /**
   * Intercom conversation id (used by the Intercom canvas).
   *
   * @generated from field: string intercom_conversation_id = 2;
   */
  intercomConversationId = "";

  constructor(data?: PartialMessage<ChargeAddonTicketRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.ChargeAddonTicketRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "intercom_conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChargeAddonTicketRequest {
    return new ChargeAddonTicketRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChargeAddonTicketRequest {
    return new ChargeAddonTicketRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChargeAddonTicketRequest {
    return new ChargeAddonTicketRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChargeAddonTicketRequest | PlainMessage<ChargeAddonTicketRequest> | undefined, b: ChargeAddonTicketRequest | PlainMessage<ChargeAddonTicketRequest> | undefined): boolean {
    return proto3.util.equals(ChargeAddonTicketRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.GetFinTokenRequest
 */
export class GetFinTokenRequest extends Message<GetFinTokenRequest> {
  constructor(data?: PartialMessage<GetFinTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.GetFinTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFinTokenRequest {
    return new GetFinTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFinTokenRequest {
    return new GetFinTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFinTokenRequest {
    return new GetFinTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFinTokenRequest | PlainMessage<GetFinTokenRequest> | undefined, b: GetFinTokenRequest | PlainMessage<GetFinTokenRequest> | undefined): boolean {
    return proto3.util.equals(GetFinTokenRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.CancelAddonPaymentRequest
 */
export class CancelAddonPaymentRequest extends Message<CancelAddonPaymentRequest> {
  /**
   * Legacy web-interface numeric ticket id (used by the website).
   *
   * @generated from field: uint64 ticket_id = 1;
   */
  ticketId = protoInt64.zero;

  /**
   * Intercom conversation id (used by the Intercom canvas).
   *
   * @generated from field: string intercom_conversation_id = 2;
   */
  intercomConversationId = "";

  constructor(data?: PartialMessage<CancelAddonPaymentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.CancelAddonPaymentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "intercom_conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelAddonPaymentRequest {
    return new CancelAddonPaymentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelAddonPaymentRequest {
    return new CancelAddonPaymentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelAddonPaymentRequest {
    return new CancelAddonPaymentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CancelAddonPaymentRequest | PlainMessage<CancelAddonPaymentRequest> | undefined, b: CancelAddonPaymentRequest | PlainMessage<CancelAddonPaymentRequest> | undefined): boolean {
    return proto3.util.equals(CancelAddonPaymentRequest, a, b);
  }
}

